import { AfterViewInit, Component, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogField, PlatformDialog } from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';

@Component({
    standalone: false,
    selector: 'app-elite-form-group-container',
  templateUrl: './elite-form-group-container.component.html',
  styleUrl: './elite-form-group-container.component.scss'
})
export class EliteFormGroupContainerComponent implements OnInit, AfterViewInit {
  @Input() dialogField: DialogField;
  @Input() platformDialog: PlatformDialog;
  @Input() parentFormGroup: FormGroup;
  @ViewChild('dynamicComponent', { read: ViewContainerRef, static: true }) viewContainerRef;

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.renderField(this.dialogField);
  }

  private renderField(df: DialogField) {
    const resolvedComponent = <Type<any>>RootDynamicComponentHelper.getComponent(df.editor);
    this.viewContainerRef.clear();
    const component = this.viewContainerRef.createComponent(resolvedComponent);
    const editorComponent = component.instance;
    editorComponent.dialogField = df;
    editorComponent.platformDialog = this.platformDialog;
    editorComponent.dynamicFormControl = this.parentFormGroup.controls[df.key];
  }
}
